import styled from "styled-components"

export const Footer = styled.footer`
  width: 100%;
  background-color: ${({ theme }) => theme.COLORS.gray};
  padding: 0.6rem 0;

  display: flex;
  justify-content: center;
`
